import React,{ useState } from 'react'
import { Singleton } from '../../../js/Singleton';
import { useEffect } from 'react';
import Dispositions from '../Dispositions';
import { useDispatch, useSelector } from 'react-redux';
import A_Alert_Modal from '../../../redux/actions/A_Alert_Modal';
import { updateInfoCall,messageToStateMachine,messageApiRequest, actionPreviewRecord  } from '../../../redux/actions/A_messages_to_SM';
import { messageAgentRedy } from '../../../js/helpers/helperMessages';
import { API_ENDPOINTS, RECORD_STATE } from '../../../constants';
import {  removeRecord, resetRecordPreview, setMaximumAssignmentPreview, setWasItwasSentPreviewTime } from '../../../redux/actions/A_preview';
import { record } from '../../../Images/CallSpaceHeaderSVG';

const language = new Singleton();

const { showAlertModal } = A_Alert_Modal.creators;

const RateCallSimultaneousPreview = ({ setShowDataLogDisp,newData}) => {
    const { selectedRecord, fReplacementJob, records, ndScheduled} = useSelector(state => state.preview);
    const [dispositionSelected, setDispositionSelected] = useState(null);
    const [reprogram, setReprogram] = useState(null); 
    const [showCanReprogram, setShowCanReprogram] = useState(false);
    const dispatch = useDispatch();
 

    useEffect(() => {
      if(dispositionSelected !== null )
      {
        setShowCanReprogram(dispositionSelected.canReprogram);

      }
    }, [dispositionSelected])

    useEffect(() => {
      setShowDataLogDisp && setShowDataLogDisp(!showCanReprogram)
      return () => {
        setShowDataLogDisp && setShowDataLogDisp(true)
      }  
    }, [showCanReprogram]);

    const endWraUpWithoutDisp = () =>{
      if(!newData.disabledUpdate)
      {
        dispatch(showAlertModal({
          type: "ModalAlert",
          title: language.getText("CallControlcallCalificationfinishWrapup"),
          message: language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"),
          button: language.getText("GUIAlertMessagefinish-and-update-btn"),
          secondButton: language.getText("GUIAlertMessagefinish-only-btn"),
          buttonFun: () => sendDataAndRemoveRec(),
          secondButtonFtn: () => removeRecAndFinishWrapUp()
        }))
      }else{
        removeRecAndFinishWrapUp();
      }
    }
    
    const endWraUpWithDisp = () =>{
      if(!newData.disabledUpdate)
      {
        dispatch(showAlertModal({
          type: "ModalAlert",
          title: language.getText("CallControlcallCalificationsave-disposition-title"),
          message: language.getText("GUIAlertMessageexitWrapUpMsgConfirmation"),
          button: language.getText("CallControlcallCalificationsave-and-update-btn"),
          secondButton: language.getText("CallControlcallCalificationsave-only-btn"),
          buttonFun: () => sendDataAndRate(),
          secondButtonFtn: () => saveDisposition()
        }))
      }else{
        saveDisposition();
      }
    }

    const saveDisposition= ()=>{
      let objectData = {
        CallId: selectedRecord.callId,
        DispositionId: dispositionSelected.dispositionSelected.Id,
        Origin: '',
        CallKey: selectedRecord.callKey,
        CallOutId: selectedRecord.callOutId,
        SubId: dispositionSelected.subDispositionSelected,
        CallType: 2,
        IsExitAssisted: dispositionSelected.dispositionSelected.FinishPreview,
        IsExitPreview: dispositionSelected.dispositionSelected.FinishRecordPreview
        
      }
      setTimeout(()=>{
        dispatch(messageApiRequest(API_ENDPOINTS.SAVE_DISPOSITION, objectData))
      },100)
      Rescheduled();
    }
    const Rescheduled = ()=>{
      if( showCanReprogram ){
        let objCallBack = {
          CamId: selectedRecord.camId,
          Phone: reprogram.phoneReprogram.selectionReschedule === 2 ? reprogram.phoneReprogram.otherPhone : reprogram.phoneReprogram.phone.number,
          TelReprograma:1, // type === 1 ? 1 : (reprogram.phoneReprogram.selectionReschedule === 2 ? 0 : reprogram.phoneReprogram.phone.id),
          IsAuto: false,
          DateDial: reprogram.dateReprogram
        }
        setTimeout(()=>{
          dispatch(messageApiRequest(API_ENDPOINTS.CALL_BACK, objCallBack))
        },200)
      }

      if(dispositionSelected.dispositionSelected.FinishRecordPreview){
        removeRecAndFinishWrapUp()
      }else{
        resetRecordAndFinishWrapUp();
      }
    };

    const sendData = () =>{
    let temp = [...newData.newArray]
      while(temp < 15)
      {
        temp.push('');
      }
      let dataPrev = {
        callKey: selectedRecord.callKey,
        camID: selectedRecord.camId,
        newData: temp
      }
      setTimeout(() => {
        dispatch(updateInfoCall(selectedRecord.callKey,selectedRecord.camId,temp,selectedRecord.callOutId))
      }, 50); 
      sendMessageAgentReady();
    }

    const sendDataAndRate=()=>{
      sendData();
      saveDisposition();
    }
    const sendDataAndRemoveRec=()=>{
      sendData();
      dispatch(removeRecord(selectedRecord.callOutId));
    }
    const removeRecAndFinishWrapUp=()=>{
      dispatch(removeRecord(selectedRecord.callOutId));
      sendMessageAgentReady();
    }

    const resetRecordAndFinishWrapUp=()=>{
      dispatch(setWasItwasSentPreviewTime({callOutId: selectedRecord.callOutId,itWasSent:false}))
      dispatch(setMaximumAssignmentPreview({callOutId: selectedRecord.callOutId, maximumAssignments: selectedRecord.maximumAssignments - 1}))
      setTimeout(()=>{
        const replacement = selectedRecord.maximumAssignments - 1 === 0 ? fReplacementJob : 0;
        dispatch(actionPreviewRecord({process:5, camId:selectedRecord.camId, callOutId:selectedRecord.callOutId,previewTime: selectedRecord.previewTime, callId:0, fMultipleJob: records.length === 1 ? 0 : 1 , fReplacementJob: replacement}));
      },100)
      setTimeout(()=>{
        
        dispatch(resetRecordPreview(selectedRecord.callOutId));
      },200)
      sendMessageAgentReady();
    }

    const sendMessageAgentReady= () => {
      let countRecordsInWrapUp = records.filter(r => ((r.status === RECORD_STATE.ALERT || r.status === RECORD_STATE.ABANDONED || r.status === RECORD_STATE.WRAPUP) && r.callOutId !== selectedRecord.callOutId))
      if(!ndScheduled)
      {
        setTimeout(()=>{
          dispatch(messageToStateMachine(messageAgentRedy()));
        },100)
      } else{
        if(countRecordsInWrapUp.length === 0){
          setTimeout(()=>{
            dispatch(messageToStateMachine(messageAgentRedy()));
          },100)
        }
      }
    }
    return (
      <div className='rcsp-container'>
        <Dispositions
        type={1}
        endWraUpWithoutDisp={endWraUpWithoutDisp}
        endWraUpWithDisp={endWraUpWithDisp}
        onChangeDisp={setDispositionSelected}
        onChangeReprogam={setReprogram}/>
      </div>
    )
}

export default RateCallSimultaneousPreview;


// WEBPACK FOOTER //
// ./src/components/workSpace/SimultaneosRecsPreview/RateCallSimultaneousPreview.jsx